module.exports = __webpack_public_path__ + "static/img/wd.f2c71a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/wd.png
// module id = 9JNh
// module chunks = 1